module.exports = __webpack_public_path__ + "img/no.074209da.png";